export default __webpack_public_path__ + "static/media/cif-ly.6fa3a094.svg";